import { ProfilePk, UnixMsString } from "./common"

export enum ProcessTypesEnum {
  POST_ADAGIN_EMPLOYEES = "POST_ADAGIN_EMPLOYEES",
  POST_AGRIGISTICS_EMPLOYEES = "POST_AGRIGISTICS_EMPLOYEES",
}

export type FieldChanges = Record<string, { old: string; new: string }>

export type DocMetaData = {
  generatedUnixMs: UnixMsString
  docFamily: string
  docName: string
}

export type LogMetaData = {
  userFirstName: string
  userSurname: string
  appVersion: string
  name: string
  surname: string
  idPassport: string
  dateActioned: UnixMsString
  profilePk: ProfilePk
}

export type ChangeLog = {
  logMetaData: LogMetaData
  docsMetaData: (DocMetaData & { op?: "create" | "remove"; unixMs?: UnixMsString })[]
  fieldChanges: FieldChanges
}
